import { Item } from './helpers/types'

export function dataLayerViewCart(value: number, items: Item[]) {
  if (!items || items.length === 0) {
    return
  }

  if (window['dataLayer']) {
    window['dataLayer'].push({ ecommerce: null })

    window['dataLayer'].push({
      event: 'view_cart',
      currency: 'EUR',
      value,
      ecommerce: {
        items,
      },
    })
  }
}
